import { render, staticRenderFns } from "./BaseRoundedButton.vue?vue&type=template&id=0f9f4a4a&scoped=true&"
import script from "./BaseRoundedButton.vue?vue&type=script&lang=js&"
export * from "./BaseRoundedButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseRoundedButton.vue?vue&type=style&index=0&id=0f9f4a4a&prod&lang=scss&scoped=true&"
import style1 from "./BaseRoundedButton.vue?vue&type=style&index=1&id=0f9f4a4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9f4a4a",
  null
  
)

export default component.exports